(function($)
{
    $.fn.ajaxArchive = function(options)
    {
        $(".js--dropdown-1").ddslick({
            onSelected: function (selectedData) {
                let value = null;
                value = selectedData.selectedData.value;

                let searchfield = null;

                if ($('.item-search-input input').val() != null) {
                    searchfield = $('.item-search-input input').val();
                }

                console.log(value);

                if (value == 0) {
                    Status = {
                        search: searchfield,
                        filter: {},
                        page: 1
                    }
                    request(Status);
                } else {
                    Status.filter['veranstaltungsarten']=value;
                    Status.page = 1;
                    request(Status);
                }


            },
        });
    };
})(jQuery);